import { inject, Injectable, Injector, runInInjectionContext } from '@angular/core';

import { CanvasElementType } from '@blaze-runtime/engine-domain';

import { ElementDefinitionsService } from '../../services/element-definitions.service';

import { ElementHandler } from './element-handler';

@Injectable({ providedIn: 'root' })
export class ElementHandlerResolver {
  private readonly elementDefinitionsService = inject(ElementDefinitionsService);
  private readonly injector = inject(Injector);
  private readonly cache = new Map<CanvasElementType, ElementHandler<CanvasElementType> | null>();

  resolve<T extends CanvasElementType>(type: T): ElementHandler<T> | null {
    if (!this.cache.has(type)) {
      this.cache.set(type, this.create(type));
    }

    return this.cache.get(type) as ElementHandler<T> | null;
  }

  private create<T extends CanvasElementType>(type: T): ElementHandler<T> | null {
    return runInInjectionContext(this.injector, () => {
      const HandlerFactory = this.elementDefinitionsService.getDefinition(type)?.ai?.handler;
      if (!HandlerFactory) {
        return null;
      }

      const HandlerClass = HandlerFactory();
      return new HandlerClass();
    });
  }
}
